export default "__VITE_ASSET__6d3d2e36__"